import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("berdhill_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setAuthToken(null))
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.requires_2fa) {
      return { requires_2fa: true, temp_token: r.data.temp_token };
    }
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }

  async function loginWith2FA(temp_token, code) {
    const r = await api.post("/auth/2fa/login", { temp_token, code });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }

  async function register(name, email, password) {
    const r = await api.post("/auth/register", { name, email, password });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }

  function logout() {
    setAuthToken(null);
    setUser(null);
  }

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginWith2FA, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
